import { createFileRoute } from "@tanstack/react-router";
import { LmsActivationRoute } from "~/features/auth/lms/LmsActivationRoute";

export const Route = createFileRoute("/lms/activate")({
  component: LmsActivationRoute,
});
